import { useQuery } from '@tanstack/react-query';
import type { Contract } from '../../models/contract.ts';
import { fetchContracts } from '../../api/partner.ts';

export default function useContracts(partnerId: string) {
  const queryFn = () => fetchContracts(partnerId);
  return useQuery<Contract[]>({
    queryKey: ['partner', partnerId, 'contracts'],
    queryFn,
  });
}
